export default {"src":"/_next/static/media/money-back-guarantee.e7c203a2.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};